module.exports = __webpack_public_path__ + "img/bing2.60dad0de.png";